import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { M as MatRippleModule } from './index-BFRo2fUq.mjs';
import { M as MatCommonModule } from './common-module-cKSwHniA.mjs';
import { M as MatOption, a as MatOptgroup } from './option-BzhYL_xC.mjs';
import { M as MatPseudoCheckboxModule } from './pseudo-checkbox-module-4F8Up4PL.mjs';
let MatOptionModule = /*#__PURE__*/(() => {
  class MatOptionModule {
    static ɵfac = function MatOptionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatOptionModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatOptionModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MatRippleModule, MatCommonModule, MatPseudoCheckboxModule, MatOption]
    });
  }
  return MatOptionModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MatOptionModule as M };
